import React, { useEffect, useState } from 'react';
import getAllLeadsEmails from '../../api/SendEmails/getAllLeadsEmails.api';
import SelectBox from '../sendEmail/selectBox/SelectBox';

const ViewLeads = ({
	viewLeads,
	handleCloseLeads,
	setAlert,
	snackbar,
	setSnackbar,
	setSnackbarType,
}) => {
	const [leadEmails, setLeadEmails] = useState();

	useEffect(() => {
		getAllLeadsEmails((returned) => {
			setLeadEmails(returned);
		});
	}, []);

	const handleSelectEmail = () => {};

	return (
		<div>
			<SelectBox
				leadEmails={leadEmails}
				handleSelectEmail={handleSelectEmail}
				path={'client'}
				handleCloseLeads={handleCloseLeads}
				setAlert={setAlert}
				snackbar={snackbar}
				setSnackbar={setSnackbar}
				setSnackbarType={setSnackbarType}
			/>
		</div>
	);
};

export default ViewLeads;
